(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/api-caller/assets/javascripts/api-map.js') >= 0) return;  svs.modules.push('/components/tur/api-caller/assets/javascripts/api-map.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const METHOD_GET = 'GET';
const METHOD_DELETE = 'DELETE';
const METHOD_POST = 'POST';
const METHOD_PUT = 'PUT';

const charityPaths = {
  getCharityExternalcharities: {
    jupiterPath: _ref => {
      let _ref$jupiterVersion = _ref.jupiterVersion,
        jupiterVersion = _ref$jupiterVersion === void 0 ? 1 : _ref$jupiterVersion;
      return "/charity/".concat(jupiterVersion, "/externalcharities");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCharityExternalcharitiesById: {
    jupiterPath: _ref2 => {
      let charityId = _ref2.charityId,
        _ref2$jupiterVersion = _ref2.jupiterVersion,
        jupiterVersion = _ref2$jupiterVersion === void 0 ? 1 : _ref2$jupiterVersion;
      return "/charity/".concat(jupiterVersion, "/externalcharities/").concat(charityId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCharityPayoutstatistics: {
    jupiterPath: _ref3 => {
      let drawIds = _ref3.drawIds,
        _ref3$jupiterVersion = _ref3.jupiterVersion,
        jupiterVersion = _ref3$jupiterVersion === void 0 ? 1 : _ref3$jupiterVersion;
      const basePath = "/charity/".concat(jupiterVersion, "/payoutstatistics");
      if (drawIds && Array.isArray(drawIds) && drawIds.length > 0) {
        const queryString = drawIds.map(id => "drawIds=".concat(id)).join('&');
        return "".concat(basePath, "?").concat(queryString);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const drawPaths = {
  getDrawProductDraws: {
    jupiterPath: _ref4 => {
      let product = _ref4.product,
        _ref4$jupiterVersion = _ref4.jupiterVersion,
        jupiterVersion = _ref4$jupiterVersion === void 0 ? 1 : _ref4$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws");
    },
    elzaPath: _ref5 => {
      let product = _ref5.product,
        _ref5$elzaVersion = _ref5.elzaVersion,
        elzaVersion = _ref5$elzaVersion === void 0 ? 'v1' : _ref5$elzaVersion;
      return "/".concat(elzaVersion, "/").concat(product, "/draws");
    },
    method: METHOD_GET
  },
  getDrawProductDrawsByDrawNumber: {
    jupiterPath: _ref6 => {
      let product = _ref6.product,
        drawNumber = _ref6.drawNumber,
        _ref6$jupiterVersion = _ref6.jupiterVersion,
        jupiterVersion = _ref6$jupiterVersion === void 0 ? 1 : _ref6$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/").concat(drawNumber);
    },
    elzaPath: _ref7 => {
      let product = _ref7.product,
        drawNumber = _ref7.drawNumber,
        _ref7$elzaVersion = _ref7.elzaVersion,
        elzaVersion = _ref7$elzaVersion === void 0 ? 'v1' : _ref7$elzaVersion;
      return "/".concat(elzaVersion, "/").concat(product, "/draws/").concat(drawNumber);
    },
    method: METHOD_GET
  },
  getDrawProductDrawsResult: {
    jupiterPath: _ref8 => {
      let product = _ref8.product,
        drawNumber = _ref8.drawNumber,
        _ref8$jupiterVersion = _ref8.jupiterVersion,
        jupiterVersion = _ref8$jupiterVersion === void 0 ? 1 : _ref8$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/").concat(drawNumber, "/result");
    },
    elzaPath: _ref9 => {
      let product = _ref9.product,
        drawNumber = _ref9.drawNumber,
        _ref9$elzaVersion = _ref9.elzaVersion,
        elzaVersion = _ref9$elzaVersion === void 0 ? 'v1' : _ref9$elzaVersion;
      return "/".concat(elzaVersion, "/").concat(product, "/draws/").concat(drawNumber, "/result");
    },
    method: METHOD_GET
  },
  getDrawProductDrawsResultByspan: {
    jupiterPath: _ref0 => {
      let product = _ref0.product,
        days = _ref0.days,
        _ref0$jupiterVersion = _ref0.jupiterVersion,
        jupiterVersion = _ref0$jupiterVersion === void 0 ? 1 : _ref0$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/result/byspan?days=").concat(days);
    },
    elzaPath: _ref1 => {
      let product = _ref1.product,
        days = _ref1.days,
        _ref1$elzaVersion = _ref1.elzaVersion,
        elzaVersion = _ref1$elzaVersion === void 0 ? 'v1' : _ref1$elzaVersion;
      return "/".concat(elzaVersion, "/").concat(product, "/draws/result/byspan?days=").concat(days);
    },
    method: METHOD_GET
  },
  getDrawProductDrawsResultLatest: {
    jupiterPath: _ref10 => {
      let product = _ref10.product,
        _ref10$jupiterVersion = _ref10.jupiterVersion,
        jupiterVersion = _ref10$jupiterVersion === void 0 ? 1 : _ref10$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/result");
    },
    elzaPath: _ref11 => {
      let product = _ref11.product,
        _ref11$elzaVersion = _ref11.elzaVersion,
        elzaVersion = _ref11$elzaVersion === void 0 ? 'v1' : _ref11$elzaVersion;
      return "/".concat(elzaVersion, "/").concat(product, "/draws/result");
    },
    method: METHOD_GET
  },
  getDrawResultsDatepicker: {
    jupiterPath: _ref12 => {
      let product = _ref12.product,
        year = _ref12.year,
        month = _ref12.month,
        _ref12$jupiterVersion = _ref12.jupiterVersion,
        jupiterVersion = _ref12$jupiterVersion === void 0 ? 1 : _ref12$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/results/datepicker?product=").concat(product, "&year=").concat(year, "&month=").concat(month);
    },
    elzaPath: _ref13 => {
      let product = _ref13.product,
        year = _ref13.year,
        month = _ref13.month,
        _ref13$elzaVersion = _ref13.elzaVersion,
        elzaVersion = _ref13$elzaVersion === void 0 ? 'v1' : _ref13$elzaVersion;
      return "/".concat(elzaVersion, "/").concat(product, "/draws/result/dates?year=").concat(year, "&month=").concat(month);
    },
    method: METHOD_GET
  },
  getDrawJackpot: {
    jupiterPath: _ref14 => {
      let product = _ref14.product,
        drawNumber = _ref14.drawNumber,
        _ref14$jupiterVersion = _ref14.jupiterVersion,
        jupiterVersion = _ref14$jupiterVersion === void 0 ? 1 : _ref14$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/jackpot/draws?product=").concat(product, "&drawNumber=").concat(drawNumber);
    },
    elzaPath: _ref15 => {
      let product = _ref15.product,
        drawNumber = _ref15.drawNumber,
        _ref15$elzaVersion = _ref15.elzaVersion,
        elzaVersion = _ref15$elzaVersion === void 0 ? 'v1' : _ref15$elzaVersion;
      return "/".concat(elzaVersion, "/jackpots/").concat(product, "/").concat(drawNumber);
    },
    method: METHOD_GET
  },
  getDrawJackpots: {
    jupiterPath: _ref16 => {
      let _ref16$jupiterVersion = _ref16.jupiterVersion,
        jupiterVersion = _ref16$jupiterVersion === void 0 ? 1 : _ref16$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/jackpots");
    },
    elzaPath: function () {
      let _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref17$elzaVersion = _ref17.elzaVersion,
        elzaVersion = _ref17$elzaVersion === void 0 ? 'v1' : _ref17$elzaVersion;
      return "/".concat(elzaVersion, "/jackpots");
    },
    method: METHOD_GET
  },
  getDrawActiveCampaigns: {
    jupiterPath: _ref18 => {
      let _ref18$jupiterVersion = _ref18.jupiterVersion,
        jupiterVersion = _ref18$jupiterVersion === void 0 ? 1 : _ref18$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/campaigns");
    },
    elzaPath: function () {
      let _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref19$elzaVersion = _ref19.elzaVersion,
        elzaVersion = _ref19$elzaVersion === void 0 ? 'v1' : _ref19$elzaVersion;
      return "/".concat(elzaVersion, "/campaignfamily/draws");
    },
    method: METHOD_GET
  },
  getDrawActiveCampaignsByProduct: {
    jupiterPath: _ref20 => {
      let product = _ref20.product,
        _ref20$jupiterVersion = _ref20.jupiterVersion,
        jupiterVersion = _ref20$jupiterVersion === void 0 ? 1 : _ref20$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/campaign/").concat(product);
    },
    elzaPath: _ref21 => {
      let product = _ref21.product,
        _ref21$elzaVersion = _ref21.elzaVersion,
        elzaVersion = _ref21$elzaVersion === void 0 ? 'v1' : _ref21$elzaVersion;
      return "/".concat(elzaVersion, "/campaign").concat(product, "/draws");
    },
    method: METHOD_GET
  },
  getDrawCampaignByCampaignDraw: {
    jupiterPath: _ref22 => {
      let product = _ref22.product,
        drawNumber = _ref22.drawNumber,
        _ref22$jupiterVersion = _ref22.jupiterVersion,
        jupiterVersion = _ref22$jupiterVersion === void 0 ? 1 : _ref22$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/campaign/").concat(product, "/").concat(drawNumber);
    },
    elzaPath: _ref23 => {
      let product = _ref23.product,
        drawNumber = _ref23.drawNumber,
        _ref23$elzaVersion = _ref23.elzaVersion,
        elzaVersion = _ref23$elzaVersion === void 0 ? 'v1' : _ref23$elzaVersion;
      return "/".concat(elzaVersion, "/campaign").concat(product, "/draws/").concat(drawNumber);
    },
    method: METHOD_GET
  },
  getDrawCampaignDatePicker: {
    jupiterPath: _ref24 => {
      let product = _ref24.product,
        year = _ref24.year,
        month = _ref24.month,
        _ref24$jupiterVersion = _ref24.jupiterVersion,
        jupiterVersion = _ref24$jupiterVersion === void 0 ? 1 : _ref24$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/campaign/datepicker?year=").concat(year, "&month=").concat(month, "&product=").concat(product);
    },
    elzaPath: _ref25 => {
      let product = _ref25.product,
        year = _ref25.year,
        month = _ref25.month,
        _ref25$elzaVersion = _ref25.elzaVersion,
        elzaVersion = _ref25$elzaVersion === void 0 ? 'v1' : _ref25$elzaVersion;
      return "/".concat(elzaVersion, "/campaign").concat(product, "/draws/dates?year=").concat(year, "&month=").concat(month);
    },
    method: METHOD_GET
  },
  getDrawCampaignResultByDraw: {
    jupiterPath: _ref26 => {
      let product = _ref26.product,
        drawNumber = _ref26.drawNumber,
        _ref26$jupiterVersion = _ref26.jupiterVersion,
        jupiterVersion = _ref26$jupiterVersion === void 0 ? 1 : _ref26$jupiterVersion;
      return "/draw/".concat(jupiterVersion, "/campaign/").concat(product, "/").concat(drawNumber, "/result");
    },
    elzaPath: _ref27 => {
      let drawNumber = _ref27.drawNumber,
        _ref27$elzaVersion = _ref27.elzaVersion,
        elzaVersion = _ref27$elzaVersion === void 0 ? 'v1' : _ref27$elzaVersion;
      return "/".concat(elzaVersion, "/campaignlotto/draws/").concat(drawNumber, "/result");
    },
    method: METHOD_GET
  },
  getDrawsTurWeek: {
    jupiterPath: _ref28 => {
      let products = _ref28.products,
        _ref28$jupiterVersion = _ref28.jupiterVersion,
        jupiterVersion = _ref28$jupiterVersion === void 0 ? 1 : _ref28$jupiterVersion;
      let basePath = "/draw/".concat(jupiterVersion, "/tur/draws/week");
      if (products) {
        basePath += "?products=".concat(products);
      }
      return basePath;
    },
    elzaPath: function () {
      let _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        products = _ref29.products,
        _ref29$elzaVersion = _ref29.elzaVersion,
        elzaVersion = _ref29$elzaVersion === void 0 ? 'v1' : _ref29$elzaVersion;
      let basePath = "/".concat(elzaVersion, "/search/draws/byweek");
      if (products !== null && products !== void 0 && products.length) {
        basePath += "?".concat(products.map(p => "product=".concat(p)).join('&'));
      }
      return basePath;
    },
    method: METHOD_GET
  }
};

const playerPaths = {
  getPlayerActiveWagers: {
    jupiterPath: _ref30 => {
      let productId = _ref30.productId,
        count = _ref30.count,
        pagingSortKey = _ref30.pagingSortKey,
        _ref30$jupiterVersion = _ref30.jupiterVersion,
        jupiterVersion = _ref30$jupiterVersion === void 0 ? 1 : _ref30$jupiterVersion;
      let basePath = "/player/".concat(jupiterVersion, "/wagers?status=Active");
      if (productId) {
        basePath += "&productId=".concat(productId);
      }
      if (count) {
        basePath += "&count=".concat(count);
      }
      if (pagingSortKey) {
        basePath += "&pagingSortKey=".concat(pagingSortKey);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerFinishedWagers: {
    jupiterPath: _ref31 => {
      let productId = _ref31.productId,
        count = _ref31.count,
        pagingSortKey = _ref31.pagingSortKey,
        _ref31$jupiterVersion = _ref31.jupiterVersion,
        jupiterVersion = _ref31$jupiterVersion === void 0 ? 1 : _ref31$jupiterVersion;
      let basePath = "/player/".concat(jupiterVersion, "/wagers?status=Finished");
      if (productId) {
        basePath += "&productId=".concat(productId);
      }
      if (count) {
        basePath += "&count=".concat(count);
      }
      if (pagingSortKey) {
        basePath += "&pagingSortKey=".concat(pagingSortKey);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerActivesubscriptions: {
    jupiterPath: _ref32 => {
      let _ref32$jupiterVersion = _ref32.jupiterVersion,
        jupiterVersion = _ref32$jupiterVersion === void 0 ? 1 : _ref32$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/activesubscriptions");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerAddress: {
    jupiterPath: _ref33 => {
      let customerId = _ref33.customerId,
        _ref33$jupiterVersion = _ref33.jupiterVersion,
        jupiterVersion = _ref33$jupiterVersion === void 0 ? 2 : _ref33$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/address?customerId=").concat(customerId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerAdressFinder: {
    jupiterPath: _ref34 => {
      let _ref34$jupiterVersion = _ref34.jupiterVersion,
        jupiterVersion = _ref34$jupiterVersion === void 0 ? 1 : _ref34$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/addressfinder");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerPreferences: {
    jupiterPath: _ref35 => {
      let _ref35$jupiterVersion = _ref35.jupiterVersion,
        jupiterVersion = _ref35$jupiterVersion === void 0 ? 1 : _ref35$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/preferences");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerPreferencesAddressGeoLocation: {
    jupiterPath: _ref36 => {
      let _ref36$jupiterVersion = _ref36.jupiterVersion,
        jupiterVersion = _ref36$jupiterVersion === void 0 ? 1 : _ref36$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/preferences/30/key?preferenceKey=addressGeoLocation");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerProperties: {
    jupiterPath: _ref37 => {
      let _ref37$jupiterVersion = _ref37.jupiterVersion,
        jupiterVersion = _ref37$jupiterVersion === void 0 ? 1 : _ref37$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/properties");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerSubscription: {
    jupiterPath: _ref38 => {
      let subscriptionId = _ref38.subscriptionId,
        _ref38$jupiterVersion = _ref38.jupiterVersion,
        jupiterVersion = _ref38$jupiterVersion === void 0 ? 1 : _ref38$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/subscription?subscription=").concat(subscriptionId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerWagerById: {
    jupiterPath: _ref39 => {
      let wagerId = _ref39.wagerId,
        _ref39$jupiterVersion = _ref39.jupiterVersion,
        jupiterVersion = _ref39$jupiterVersion === void 0 ? 1 : _ref39$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/wagers/").concat(wagerId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerWagerByStatus: {
    jupiterPath: _ref40 => {
      let branding = _ref40.branding,
        _ref40$jupiterVersion = _ref40.jupiterVersion,
        jupiterVersion = _ref40$jupiterVersion === void 0 ? 1 : _ref40$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/wagers?status=Active&productId=").concat(branding);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerSuspensions: {
    jupiterPath: _ref41 => {
      let _ref41$jupiterVersion = _ref41.jupiterVersion,
        jupiterVersion = _ref41$jupiterVersion === void 0 ? 1 : _ref41$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/suspensions");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerDepositlimits: {
    jupiterPath: _ref42 => {
      let _ref42$jupiterVersion = _ref42.jupiterVersion,
        jupiterVersion = _ref42$jupiterVersion === void 0 ? 2 : _ref42$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/depositlimits");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerObjectstore: {
    jupiterPath: _ref43 => {
      let keys = _ref43.keys,
        _ref43$jupiterVersion = _ref43.jupiterVersion,
        jupiterVersion = _ref43$jupiterVersion === void 0 ? 1 : _ref43$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/objectstore?keys=").concat(keys);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  postPlayerObjectstore: {
    jupiterPath: _ref44 => {
      let _ref44$jupiterVersion = _ref44.jupiterVersion,
        jupiterVersion = _ref44$jupiterVersion === void 0 ? 1 : _ref44$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/objectstore");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  getPlayerSettings: {
    jupiterPath: _ref45 => {
      let _ref45$jupiterVersion = _ref45.jupiterVersion,
        jupiterVersion = _ref45$jupiterVersion === void 0 ? 1 : _ref45$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/settings");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  putPlayerSettings: {
    jupiterPath: _ref46 => {
      let _ref46$jupiterVersion = _ref46.jupiterVersion,
        jupiterVersion = _ref46$jupiterVersion === void 0 ? 1 : _ref46$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/settings");
    },
    elzaPath: () => null,
    method: METHOD_PUT
  },
  getPlayerReserved: {
    jupiterPath: _ref47 => {
      let product = _ref47.product,
        _ref47$jupiterVersion = _ref47.jupiterVersion,
        jupiterVersion = _ref47$jupiterVersion === void 0 ? 1 : _ref47$jupiterVersion;
      let basePath = "/player/".concat(jupiterVersion, "/marketplace/svs/activateddraws/reserved");
      if (product) {
        basePath += "?product=".concat(product);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerSponsorshipReceiverSelection: {
    jupiterPath: _ref48 => {
      let _ref48$active = _ref48.active,
        active = _ref48$active === void 0 ? true : _ref48$active,
        _ref48$jupiterVersion = _ref48.jupiterVersion,
        jupiterVersion = _ref48$jupiterVersion === void 0 ? 1 : _ref48$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/sponsorship/receiverselection?active=").concat(active);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerValidatedTicket: {
    jupiterPath: _ref49 => {
      let ticketNumber = _ref49.ticketNumber,
        _ref49$jupiterVersion = _ref49.jupiterVersion,
        jupiterVersion = _ref49$jupiterVersion === void 0 ? 1 : _ref49$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/validatedticket?ticketnumber=").concat(ticketNumber);
    },
    elzaPath: _ref50 => {
      let ticketNumber = _ref50.ticketNumber;
      return "/v1/validatedtickets/me/".concat(ticketNumber);
    },
    method: METHOD_GET,
    useCredentials: true
  },
  getPlayerInfo: {
    jupiterPath: _ref51 => {
      let _ref51$jupiterVersion = _ref51.jupiterVersion,
        jupiterVersion = _ref51$jupiterVersion === void 0 ? 3 : _ref51$jupiterVersion;
      return "/player/".concat(jupiterVersion, "/info?include=accountBalance,currentStatus");
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const marketplacePaths = {
  getMarketplaceContainers: {
    jupiterPath: _ref52 => {
      let product = _ref52.product,
        _ref52$jupiterVersion = _ref52.jupiterVersion,
        jupiterVersion = _ref52$jupiterVersion === void 0 ? 1 : _ref52$jupiterVersion;
      let basePath = "/marketplace/".concat(jupiterVersion, "/svs/containers");
      if (product) {
        basePath += "?product=".concat(product);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getMarketplaceActivatedDrawsById: {
    jupiterPath: _ref53 => {
      let activatedDrawId = _ref53.activatedDrawId,
        _ref53$jupiterVersion = _ref53.jupiterVersion,
        jupiterVersion = _ref53$jupiterVersion === void 0 ? 1 : _ref53$jupiterVersion;
      return "/marketplace/".concat(jupiterVersion, "/svs/activateddraws/").concat(activatedDrawId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  postMarketplaceActivatedDrawsSoldSharesByDrawId: {
    jupiterPath: _ref54 => {
      let drawId = _ref54.drawId,
        _ref54$jupiterVersion = _ref54.jupiterVersion,
        jupiterVersion = _ref54$jupiterVersion === void 0 ? 1 : _ref54$jupiterVersion;
      return "/marketplace/".concat(jupiterVersion, "/activateddraws/").concat(drawId, "/soldshares");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
};

const subscriptionPaths = {
  postSubscriptionDisable: {
    jupiterPath: _ref55 => {
      let _ref55$jupiterVersion = _ref55.jupiterVersion,
        jupiterVersion = _ref55$jupiterVersion === void 0 ? 2 : _ref55$jupiterVersion;
      return "/subscription/".concat(jupiterVersion, "/disablesubscription");
    },
    elzaPath: () => null,
    method: METHOD_PUT
  },
  postSubscriptionSelectCharity: {
    jupiterPath: _ref56 => {
      let _ref56$jupiterVersion = _ref56.jupiterVersion,
        jupiterVersion = _ref56$jupiterVersion === void 0 ? 2 : _ref56$jupiterVersion;
      return "/subscription/".concat(jupiterVersion, "/selectcharity");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
};

const wagerPaths = {
  deleteWager: {
    jupiterPath: _ref57 => {
      let wagerId = _ref57.wagerId,
        _ref57$jupiterVersion = _ref57.jupiterVersion,
        jupiterVersion = _ref57$jupiterVersion === void 0 ? 5 : _ref57$jupiterVersion;
      return "/wager/".concat(jupiterVersion, "/wagers/").concat(wagerId);
    },
    elzaPath: () => null,
    method: METHOD_DELETE
  },
  postWagerWagers: {
    jupiterPath: _ref58 => {
      let _ref58$jupiterVersion = _ref58.jupiterVersion,
        jupiterVersion = _ref58$jupiterVersion === void 0 ? 10 : _ref58$jupiterVersion;
      return "/wager/".concat(jupiterVersion, "/wagers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postWagerMultiwagers: {
    jupiterPath: _ref59 => {
      let _ref59$jupiterVersion = _ref59.jupiterVersion,
        jupiterVersion = _ref59$jupiterVersion === void 0 ? 10 : _ref59$jupiterVersion;
      return "/wager/".concat(jupiterVersion, "/multiwagers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
};

const socialPaths = {
  getSocialSyndicates: {
    jupiterPath: _ref60 => {
      let _ref60$jupiterVersion = _ref60.jupiterVersion,
        jupiterVersion = _ref60$jupiterVersion === void 0 ? 2 : _ref60$jupiterVersion;
      return "/social/".concat(jupiterVersion, "/syndicates");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getSocialSyndicatesById: {
    jupiterPath: _ref61 => {
      let syndicateId = _ref61.syndicateId,
        _ref61$jupiterVersion = _ref61.jupiterVersion,
        jupiterVersion = _ref61$jupiterVersion === void 0 ? 1 : _ref61$jupiterVersion;
      return "/social/".concat(jupiterVersion, "/syndicates/").concat(syndicateId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getSocialSyndicateNamesById: {
    jupiterPath: _ref62 => {
      let syndicateId = _ref62.syndicateId,
        _ref62$jupiterVersion = _ref62.jupiterVersion,
        jupiterVersion = _ref62$jupiterVersion === void 0 ? 1 : _ref62$jupiterVersion;
      return "/social/".concat(jupiterVersion, "/syndicatenames/").concat(syndicateId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};


const extraChanserPaths = {
  getCustomerResultsInfo: {
    jupiterPath: _ref63 => {
      let _ref63$productId = _ref63.productId,
        productId = _ref63$productId === void 0 ? 0 : _ref63$productId,
        _ref63$drawnum = _ref63.drawnum,
        drawnum = _ref63$drawnum === void 0 ? 0 : _ref63$drawnum,
        _ref63$getAllDraws = _ref63.getAllDraws,
        getAllDraws = _ref63$getAllDraws === void 0 ? true : _ref63$getAllDraws,
        _ref63$jupiterVersion = _ref63.jupiterVersion,
        jupiterVersion = _ref63$jupiterVersion === void 0 ? 1 : _ref63$jupiterVersion;
      return "/extrachanser/".concat(jupiterVersion, "/customerresultsinfo?productId=").concat(productId, "&drawnum=").concat(drawnum, "&getAllDraws=").concat(getAllDraws);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCustomerResultsInfoExt: {
    jupiterPath: _ref64 => {
      let accessToken = _ref64.accessToken,
        _ref64$jupiterVersion = _ref64.jupiterVersion,
        jupiterVersion = _ref64$jupiterVersion === void 0 ? 1 : _ref64$jupiterVersion;
      return "/extrachanser/".concat(jupiterVersion, "/customerresultsinfoext?uuid=").concat(accessToken);
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};


const contentPaths = {
  getContentWithIds: {
    jupiterPath: _ref65 => {
      let ids = _ref65.ids,
        _ref65$routesDomain = _ref65.routesDomain,
        routesDomain = _ref65$routesDomain === void 0 ? 'tur' : _ref65$routesDomain,
        _ref65$jupiterVersion = _ref65.jupiterVersion,
        jupiterVersion = _ref65$jupiterVersion === void 0 ? 2 : _ref65$jupiterVersion;
      let basePath = "/content/".concat(jupiterVersion, "/id");
      if (ids) {
        const idsArray = Array.isArray(ids) ? ids : [ids];
        basePath += "?ids=".concat(idsArray.join(','));
      }
      if (routesDomain) {
        basePath += "&routesDomain=".concat(routesDomain);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const ticketPaths = {
  postPlayerValidateTicket: {
    jupiterPath: _ref66 => {
      let _ref66$jupiterVersion = _ref66.jupiterVersion,
        jupiterVersion = _ref66$jupiterVersion === void 0 ? 1 : _ref66$jupiterVersion;
      return "/ticket/".concat(jupiterVersion, "/playervalidateticket");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postPersonalVouchers: {
    jupiterPath: _ref67 => {
      let _ref67$jupiterVersion = _ref67.jupiterVersion,
        jupiterVersion = _ref67$jupiterVersion === void 0 ? 1 : _ref67$jupiterVersion;
      return "/ticket/".concat(jupiterVersion, "/personalvouchers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postMailboxPlayerOrder: {
    jupiterPath: _ref68 => {
      let _ref68$jupiterVersion = _ref68.jupiterVersion,
        jupiterVersion = _ref68$jupiterVersion === void 0 ? 1 : _ref68$jupiterVersion;
      return "/ticket/".concat(jupiterVersion, "/mailbox/playerorder");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postMailboxGiftOrder: {
    jupiterPath: _ref69 => {
      let _ref69$jupiterVersion = _ref69.jupiterVersion,
        jupiterVersion = _ref69$jupiterVersion === void 0 ? 1 : _ref69$jupiterVersion;
      return "/ticket/".concat(jupiterVersion, "/mailbox/giftorder");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  getMailBoxOrderReferenceId: {
    jupiterPath: _ref70 => {
      let referenceId = _ref70.referenceId,
        _ref70$jupiterVersion = _ref70.jupiterVersion,
        jupiterVersion = _ref70$jupiterVersion === void 0 ? 1 : _ref70$jupiterVersion;
      return "/ticket/".concat(jupiterVersion, "/mailbox/orders/").concat(referenceId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  postGiftVouchers: {
    jupiterPath: _ref71 => {
      let _ref71$jupiterVersion = _ref71.jupiterVersion,
        jupiterVersion = _ref71$jupiterVersion === void 0 ? 1 : _ref71$jupiterVersion;
      return "/ticket/".concat(jupiterVersion, "/giftvouchers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
};

const voucherPaths = {
  postVoucherSendBySms: {
    jupiterPath: _ref72 => {
      let _ref72$jupiterVersion = _ref72.jupiterVersion,
        jupiterVersion = _ref72$jupiterVersion === void 0 ? 1 : _ref72$jupiterVersion;
      return "/voucher/".concat(jupiterVersion, "/sendbysms");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  getVoucherById: {
    jupiterPath: _ref73 => {
      let voucherId = _ref73.voucherId,
        _ref73$jupiterVersion = _ref73.jupiterVersion,
        jupiterVersion = _ref73$jupiterVersion === void 0 ? 6 : _ref73$jupiterVersion;
      return "/voucher/".concat(jupiterVersion, "/getvoucher/?voucherId=").concat(voucherId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getVoucherMetadata: {
    jupiterPath: _ref74 => {
      let voucherId = _ref74.voucherId,
        _ref74$jupiterVersion = _ref74.jupiterVersion,
        jupiterVersion = _ref74$jupiterVersion === void 0 ? 1 : _ref74$jupiterVersion;
      return "/voucher/".concat(jupiterVersion, "/vouchermetadata?voucherId=").concat(voucherId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getVouchersConfig: {
    jupiterPath: _ref75 => {
      let _ref75$jupiterVersion = _ref75.jupiterVersion,
        jupiterVersion = _ref75$jupiterVersion === void 0 ? 1 : _ref75$jupiterVersion;
      return "/voucher/".concat(jupiterVersion, "/vouchersconfig");
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const AuthorizationPaths = {
  getAuthorizationOath2: {
    jupiterPath: _ref76 => {
      let _ref76$jupiterVersion = _ref76.jupiterVersion,
        jupiterVersion = _ref76$jupiterVersion === void 0 ? 1 : _ref76$jupiterVersion;
      return "/authorization/".concat(jupiterVersion, "/oauth2/auth");
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};
const apiMap = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, charityPaths), drawPaths), playerPaths), marketplacePaths), wagerPaths), socialPaths), subscriptionPaths), extraChanserPaths), contentPaths), ticketPaths), voucherPaths), AuthorizationPaths), {}, {
  getCacheTokens: {
    jupiterPath: _ref77 => {
      let accessToken = _ref77.accessToken,
        _ref77$jupiterVersion = _ref77.jupiterVersion,
        jupiterVersion = _ref77$jupiterVersion === void 0 ? 2 : _ref77$jupiterVersion;
      return "/cache/".concat(jupiterVersion, "/tokens/").concat(accessToken);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCustomerbetWagerByDraw: {
    jupiterPath: _ref78 => {
      let product = _ref78.product,
        drawNumber = _ref78.drawNumber,
        _ref78$jupiterVersion = _ref78.jupiterVersion,
        jupiterVersion = _ref78$jupiterVersion === void 0 ? 1 : _ref78$jupiterVersion;
      return "/customerbet/".concat(jupiterVersion, "/wager/by/draw?product=").concat(product, "&drawNumber=").concat(drawNumber);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  postGeoSelectCharity: {
    jupiterPath: _ref79 => {
      let _ref79$jupiterVersion = _ref79.jupiterVersion,
        jupiterVersion = _ref79$jupiterVersion === void 0 ? 2 : _ref79$jupiterVersion;
      return "/geo/".concat(jupiterVersion, "/selectcharity");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
});
if (svs.isServer) {
  module.exports = {
    apiMap
  };
} else {
  setGlobal('svs.tur.apiCaller.apiMap', apiMap);
}

 })(window);